"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _Operators = require("AudienceTargetingUIComponents/constants/Operators");

var FilterRecord = (0, _immutable.Record)({
  operator: _Operators.EQ,
  values: undefined,
  type: null
});
var _default = FilterRecord;
exports.default = _default;
module.exports = exports.default;